import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SmsLineAccountService} from '../../services/sms-line-account.service';
import {AuthService} from '../../../../../core/service/auth.service';

const SELECT_LINE_ACCOUNT_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectSmsLineAccountComponent)
};

@Component({
  selector: 'app-select-sms-line-account',
    template: `
      <ngx-select [items]="lines" [(ngModel)]="line" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" allowClear="true">
          <ng-template ngx-select-option let-option let-text="text">
              {{ option.data.name }} <br />
              <small>Price: <strong>{{option.data.price}}</strong></small>
          </ng-template>
          <ng-template ngx-select-option-selected let-option let-text="text">
              {{ option.data.name }}
          </ng-template>
      </ngx-select>
      `,
  styleUrls: ['./select-sms-line-account.component.scss'],
    providers: [SELECT_LINE_ACCOUNT_VALUE_ACCESSOR]
})
export class SelectSmsLineAccountComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';

    lines: Object;
    _line: number;

    constructor(private smsLineAccountService: SmsLineAccountService, private auth: AuthService) { }

    selected(value: any) {
        this.propagateChange(this._line);
    }


    get line(): any { return this._line; };

    set line(v: any) {

        this._line = v;
        this.propagateChange(this._line);
    }

    propagateChange = (_: any) => {};
    onTouched = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._line = value;
    }

    ngOnInit() {
        this.smsLineAccountService.getLinesAccount({'portal_pk' : this.auth.getPkPortal()}).subscribe(
            (result) => {
                this.lines = result;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/sms/components/select-sms-line-account/select-sms-line-account.component.ts